###
Accept a callback function that will recieve an instance of the api

Usage:
  prismic = require '@/services/prismic/api'
  module.exports =
    data: -> cms: null
    created: ->
      prismic (api) -> api.getSingle 'homepage'
      .then (response) => @cms = response.data

###
Prismic = require 'prismic-javascript'
endpoint = 'https://bukwild-show.prismic.io/api/v2'
module.exports = (cb) ->
  Prismic.getApi endpoint
  .then (api) -> cb(api)



// WEBPACK FOOTER //
// ./src/utils/prismic/api.coffee